/**
 * Server-side structured data for the HomebuyerReadinessScore tool page.
 * Lives in a data module (not the page component) so routeMeta can emit it
 * into the server HTML; react-helmet would only add it after hydration.
 */
import { FAQS } from "@/components/tools/readinessScoreData";

export const PAGE_URL = "https://www.homeapproach.com/tools/homebuyer-readiness-score";

  /** Single source of truth for the visible "Last reviewed" label and schema dateModified. Keep both in sync. */
export const LAST_REVIEWED = "August 2026";
export const LAST_REVIEWED_ISO = "2026-08";

export const HOMEBUYER_READINESS_SCORE_JSON_LD: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      name: "What Is a Homebuyer Readiness Score?",
      description:
        "How homebuyer readiness scores work: the five factors, a sample weighted formula, score bands, worked examples, and a free calculator that estimates where you stand before applying for a mortgage.",
      url: PAGE_URL,
      dateModified: LAST_REVIEWED_ISO,
      mainEntity: {
        "@type": "WebApplication",
        name: "Homebuyer Readiness Score calculator",
        url: `${PAGE_URL}#calculator`,
        applicationCategory: "FinanceApplication",
        operatingSystem: "Web",
      },
      inLanguage: "en-US",
      isPartOf: { "@type": "WebSite", name: "Home Approach", url: "https://www.homeapproach.com" },
      publisher: {
        "@type": "Organization",
        name: "Home Approach",
        url: "https://www.homeapproach.com",
        logo: { "@type": "ImageObject", url: "https://www.homeapproach.com/og-image.png" },
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://www.homeapproach.com/" },
        { "@type": "ListItem", position: 2, name: "Tools", item: "https://www.homeapproach.com/tools" },
        { "@type": "ListItem", position: 3, name: "Homebuyer Readiness Score", item: PAGE_URL },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};
